<form [formGroup]="logFilterForm" class="log-filters">
    <div class="filter-inputs">
        <tui-input-date
                toNativeDate
                [tuiTextfieldCleaner]="true"
                tuiTextfieldSize="s"
                [tuiTextfieldLabelOutside]="true"
                formControlName="date"
        >
            Любая дата
        </tui-input-date>

        <nb-select formControlName="type" placeholder="Все действия" size="small" shape="semi-round">
            <nb-option>Все действия</nb-option>
            <nb-option [value]="type.id" *ngFor="let type of logTypes">{{type.header}}</nb-option>
        </nb-select>
    </div>
</form>

<div *ngFor="let dayLog of filteredLogs">
  <div class="dateLog text-center mb-1">{{dayLog.createdAt | date: 'dd.MM.yyyy'}}</div>
  <div class="issue-left-column-item-text issue-logs row mb-3" *ngFor="let log of dayLog.logs">
    <div class="col-sm-2">
      {{log.createdAt | date: 'HH:mm:ss'}}
    </div>
    <div class="col-sm-8">
      {{getChangeContent(log)}}
    </div>
    <div class="col-sm-2">
      <span [nbTooltip]="log.createdBy.lastName + ' ' + log.createdBy.firstName"><tui-avatar size="s" [src]="log.createdBy.picture ? getPictureSrc(log.createdBy.picture) : (log.createdBy.lastName + ' ' + log.createdBy.firstName) | tuiInitials"></tui-avatar></span>
    </div>
  </div>
</div>
